import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  debug: true,
  fallbackLng: "fa",
  interpolation: {
    escapeValue: false,
  },
  // language resources
  resources: {
    en: {
      translation: {
        welcome: "welcome",
        login: "login",
        forgotPassword: "Forgot password",
        or: "or",
        userName: "User name",
        password: "password",
        donthaveAccount: "don't have account? sign up",
        mobileLogin: "Login with Mobile Number",
        passwordRecovery: "Reset password",
        mobileNumber: "Mobile Number",
        MobileLoginAuthCode: "Enter verification code",
        Signup: "Sign up",
        SmsSent: "Sms has been sent",
        NationalCodeOrPassport: "National Code/Passport id",
        Email: "Email",
        RepeatPassowrd: "Repeat Password",
        TermsAndCondition: "Terms and Conditions",
        Iaccept: "I accept",
        Iranian: "Iranian",
        Foreign: "Foreigner",
        CurrentPatientList: "Current patient list",
        PatientList: "Patient list",
        CompleteProfile: "Complete user profile",
        NewRedirect: "New patient referral",
        AboutUS: "About us",
        UploadOnCall: "Send or view on call documents",
        ContactUS: "Contact us",
        ConferServicesList: "View services",
        BankAccounts: "Bank accounts",
        PasswordChage: "Change password",
        ServiceSummurary: "Services Summurary",
        AddNewService: "Add new services",
        EditService: "Edit service",
        AddNewFile: "Add new E-file",
        Message: "Messages",
        ReferralTo: "Reffer to",
        PatientFileEdit: "Edit E-file",
        CurrentPatients: "Current patients",
        PerformanceReport: "Performance report",
        FileUpload: "Upload file",
        Salary: "Salary",
        NewAppointment: "Get appointment",
        Appointments: "Appointments",
        CanceledAppointments: "Canceled Appointments",
        UploadDocuments: "Upload documents",
        Manual: "Manual",
        UploadImage: "Upload image",
        Logout: "Logout",
        Name: "Name",
        Family: "Last name",
        FatherName: "Father's name",
        BirthCity: "Birth city",
        CityLive: "City of live",
        BirthDay: "Birthday",
        Addresss: "Address",
        Telephone: "Telephone",
        Save: "Save",
        SendDocument: "Send documents",
        ViewDocument: "View documents",
        File: "File",
        Picture: "Picture",
        Download: "Download",
        UserDocument: "Documnet",
        ChooseExpirationDate: "Choose expiration date",
        DocumentType: "Document Type",
        Description: "Description",
        SearchPatient: "Patient search",
        All: "All",
        Finished: "Finished",
        Canceled: "Canceled",
        DiagnosisList: "Diagnosis list",
        InsuranceList: "Insurance List",
        NationalCodeName: "Name/NationalCode",
        NFI: "National code / Id / File id",
        Date: "Date",
        Time: "Time",
        Service: "Service",
        provider: "Provider",
        BankAccountList: "Bank account list",
        CardNumber: "Card Number",
        AccountNumber: "Account Number",
        SabaNumber: "Saba Number",
        Bank: "Bank",
        AddAccount: "Add account",
        EditAccount: "Edit account",
        ActivateAccount: "Activate",
        DeleteAccount: "Delete",
        DeactivateAccount: "Deactivate Account",
        ChangePassword: "Change password",
        CurrentPassword: "Current Password",
        NewPassword: "New Password",
        AddServices: "Add services",
        MedicalFile: "Medical file",
        EndActivity: "Finish activity",
        ShowServices: "Show Services",
        CancelReferral: "Cancel referral",
        ReferTo: "Refer to",
        InsuranceType: "Insurance type",
        DiscountCenter: "Discount center",
        DiscountDoctor: "Discount doctor",
        ServiceSearch: "Search services",
        Warning: "Warning",
        error: "error",
        Yes: "Yes",
        No: "No",
        Accept: "Accept",
        Cancel: "Cancel",
        Done: "Done",
        Operation: "Operation",
        NoDataEntered: "No data entered",
        AreyouSureEndActivity: "Are you sure you want to end the activity?",
        NoData: "No data",
        Payable: "Payable",
        Settlement: "Settlement",
        Edit: "Edit",
        Discount: "Discount",
        Settled: "Settled",
        NotSettled: "NotSettled",
        ConfirmSettle: "Are you sure you want to settle?",
        ConfirmDelete: "Are you sure you want to Delete?",
        CancelSuccessful: "Successfully canceled",
        ConfirmCancel: "Are you sure you want to cancel referral?",
        GetDateList: "Get date list",
        SessionCount: "Session count",
        DayGap: "Day gap",
        TimePresence: "Time presence",
        PresenceTime: "Presence time",
        SpecialDays: "Special days",
        DaysOfWeek: "Days of the week",
        Patient: "Patient",
        NoNationalCode: "No national code",
        Sessions: "Sessions",
        PresenceDate: "Presence date",
        Diagnose: "Diagnose",
        Doctors: "Doctors",
        DownloadingManual: "Downloading manual",
        TokenExpired: "Token expired",
        From: "From",
        To: "To",
        Settings: "Settings",
        English: "English",
        Persian: "Persian",
        Language: "Language",
        Font: "Font",
        SelectAService: "Select a Service",
        ConfirmSettlment: "Confirm Settlment?",
        AddPatientForm: "Are you sure you want to add this form",
        EditPatientForm: "Are you sure you want to edit this form",
        FillEmptyFields: "Please fill empty fields",
        NetworkError: "Network Error",
        SaveTheForm: "Save the form",
        Confirmed: "Confirmed",
        NotConfirmed: "Not confirmed",
        Color: "Color",
        Themes: "Themes",
        DisplayMode: "Display Mode",
        SpeechToText: "Speech to Text",
        BrowserNotSupported: "Unsupported Browser",
        MoreRows: "More rows rows in menu",
        Microphone: "Microphone",
        PatientPayable: "Patient part",
        InsurancePart: "Insurance part",
        TotalPrice: "Total price",
        PleaseSelectItem: "Please select item",
        Search: "Search",
        AddConferPermission: "Are you sure you want to add confer?",
        EditConferPermission: "Are you sure you want to edit confer",
        ConfirmAfterAddConfer: "Do you want a Bill ?",
        warning: "warning",
      },
    },
    fa: {
      translation: {
        welcome: "خوش آمدید",
        login: "ورود",
        forgotPassword: "فراموشی رمز",
        or: "یا",
        userName: "نام کاربری",
        password: "رمز عبور",
        donthaveAccount: "حساب کاربری ندارید؟ ثبت نام کنید",
        mobileLogin: "ورود با شماره تلفن همراه",
        passwordRecovery: "باز نشانی رمز عبور",
        mobileNumber: "شماره موبایل",
        MobileLoginAuthCode: "ورود کد احراز هویت",
        Signup: "ثبت نام",
        SmsSent: "پیامک با موفقیت ارسال شد",
        NationalCodeOrPassport: "کدملی / شماره پاسپورت",
        Email: "پست الکترونیک",
        RepeatPassowrd: "تکرار رمز",
        TermsAndCondition: "قوانین و شرایط",
        Iaccept: "را می پذیرم",
        Iranian: "ایرانی",
        Foreign: "غیر ایرانی",
        CurrentPatientList: "لیست بیماران جاری",
        PatientList: "لیست بیماران",
        CompleteProfile: "تکمیل اطلاعات",
        NewRedirect: "ارجاع جدید",
        AboutUS: "درباره ما",
        UploadOnCall: "مشاهده و ارسال مدارک درمانگر",
        ContactUS: "تماس با ما",
        ConferServicesList: "مشاهده خدمات",
        BankAccounts: "لیست حساب ها",
        PasswordChage: "تغییر رمز",
        ServiceSummurary: "خلاصه خدمات",
        AddNewService: "ثبت خدمت",
        EditService: "ویرایش خدمت",
        AddNewFile: "ثبت پرونده",
        Message: "پیام ها",
        ReferralTo: "ارجاع به",
        PatientFileEdit: "ویرایش فرم بیمار",
        CurrentPatients: "بیماران جاری",
        PerformanceReport: "گزارش عملکرد",
        FileUpload: "بارگذاری فایل",
        Salary: "حق الزحمه",
        NewAppointment: "اخذ نوبت",
        Appointments: "نوبت ها",
        CanceledAppointments: "نوبت های لغو شده",
        UploadDocuments: "بارگذاری مدارک",
        Manual: "راهنما",
        UploadImage: "بارگذاری عکس",
        Logout: "خروج",
        Name: "نام",
        Family: "نام خانوادگی",
        FatherName: "نام پدر",
        BirthCity: "شهر محل تولد",
        CityLive: "شهر محل سکونت",
        BirthDay: "تارخ تولد",
        Addresss: "آدرس",
        Telephone: "تلفن ثابت",
        Save: "ثبت",
        SendDocument: "ارسال مدارک",
        ViewDocument: '"مشاهده مدارک"',
        File: "فایل",
        Picture: "تصویر",
        Download: "بارگیری",
        UserDocument: "مدرک",
        ChooseExpirationDate: "انتخاب تاریخ انقضا",
        DocumentType: "نوع مدرک",
        Description: "توضیحات",
        SearchPatient: "جستجوی بیمار",
        All: "همه",
        Finished: "مختومه",
        Canceled: "انصرافی",
        DiagnosisList: "لیست بیمه",
        InsuranceList: "لیست بیمه ها",
        NationalCodeName: "نام نام خانوادگی / کدملی",
        NFI: "کدملی / شناسه / شماره پرونده",
        Date: "تاریخ",
        Time: "زمان",
        Service: "خدمت",
        provider: "انجام دهنده",
        BankAccountList: "فهرست حساب های بانکی",
        CardNumber: "شماره کارت",
        AccountNumber: "شماره حساب",
        SabaNumber: "شماره شبا",
        Bank: "بانک",
        AddAccount: "افزودن حساب",
        EditAccount: "ویرایش حساب",
        ActivateAccount: "فعالسازی حساب",
        DeleteAccount: "حذف",
        DeactivateAccount: "غیر فعالسازی حساب",
        ChangePassword: "تغییر گذواژه",
        CurrentPassword: "رمز فعلی",
        NewPassword: "رمز جدید",
        AddServices: "ثبت خدمات",
        MedicalFile: "پرونده پزشکی",
        EndActivity: "پایان فعالیت",
        ShowServices: "مشاهده خدمات",
        CancelReferral: "انصراف از ارجاع",
        ReferTo: "ارجاع به",
        InsuranceType: "نوع بیمه",
        DiscountCenter: "تخفیف مرکز",
        DiscountDoctor: "تخفیف بیمه",
        ServiceSearch: "جستجوی خدمات",
        Warning: "  ",
        Yes: "بله",
        No: "خیر",
        Accept: "تایید",
        Cancel: "لغو",
        Done: "انجام عملیات",
        Operation: "عملیات",
        error: "  ",
        NoDataEntered: "هیچ داده ای وارد نشده است",
        AreyouSureEndActivity: "آیا از پایان فعالیت اطمینان دارید؟",
        NoData: "داده ای موجود نیست",
        Payable: "قابل پرداخت",
        Settlement: "تسویه",
        Edit: "ویرایش",
        Discount: "تخفیف",
        Settled: "تسویه شده",
        NotSettled: "تسویه نشده",
        ConfirmSettle: "آیا از تسویه اطمینان دارید؟",
        ConfirmDelete: "آیا از حذف اطمینان دارید؟",
        CancelSuccessful: "با موفقیت لغو شد",
        ConfirmCancel: "آیااز انصراف از ارجاع اطمینان دارید؟",
        GetDateList: "دریافت فهرست تاریخ",
        SessionCount: "تعداد جلسات",
        DayGap: "فاصله روز ها",
        TimePresence: "فاصله روز ها",
        PresenceTime: "زمان حضور",
        SpecialDays: "روز های خاص",
        DaysOfWeek: "روز های هفته",
        Patient: "بیمار",
        NoNationalCode: "فاقد کد ملی",
        Sessions: "جلسات",
        PresenceDate: "تاریخ حضور",
        Diagnose: "تشخیص",
        Doctors: "پزشکان",
        DownloadingManual: "درحال دانلود راهنما",
        TokenExpired: "توکن منقضی شده",
        From: "از",
        To: "تا",
        Settings: "تنظیمات",
        English: "انگلیسی",
        Persian: "فارسی",
        Language: "زبان",
        Font: "فونت",
        SelectAService: "خدمتی انتخاب نمایید",
        ConfirmSettlment: "آیا با تسویه ثبت شود؟",
        AddPatientForm: "آیا از ثبت فرم اطمینان دارید",
        EditPatientForm: "آیا از ویرایش فرم اطمینان دارید",
        FillEmptyFields: "فیلد های خالی را پر کنید",
        NetworkError: "خطا در شبکه",
        SaveTheForm: "ثبت فرم",
        Confirmed: "تایید شده",
        NotConfirmed: "تایید نشده",
        Color: "رنگ",
        Themes: "رنگ بندی",
        DisplayMode: "حالت نمایش",
        SpeechToText: "گفتار به متن",
        BrowserNotSupported: "مرورگر پشتیبانی نمیشود",
        MoreRows: "ستون های بیشتر",
        Microphone: "میکروفن",
        PatientPayable: "سهم بیمار",
        InsurancePart: "سهم بیمه",
        TotalPrice: "مبلغ کل",
        PleaseSelectItem: "چیزی انتخاب نشده است",
        Search: "جستجو",
        AddConferPermission: "آیا از ثبت خدمت اطمینان دارید؟",
        EditConferPermission: "آیا از ویرایش خدمات اطمینان دارید؟",
        ConfirmAfterAddConfer: "آیا قبض صادر شود؟",
        warning: "هشدار",
      },
    },
  },
});

export default i18n;
